module.exports = __webpack_public_path__ + "static/headshot-e4bb73e5336744dd562791071024f4cd.jpg";